import React from 'react';
import { Save } from 'styled-icons/material';
import { MDBBtn } from 'mdb-react-ui-kit';

const GenericBtn = (props) =>
    <MDBBtn color={props.color} className='bg-gradient' {...props}>
        {props.children}
    </MDBBtn>

export const PrimaryBtn = (props) =>
    <GenericBtn color='korprimary' {...props} />

export const SecondaryBtn = (props) =>
    <GenericBtn color='korsecondary' {...props} />

export const DangerBtn = (props) => <GenericBtn color='danger' {...props} />

export const SuccessBtn = (props) => <GenericBtn color='success' {...props} />

export const SaveBtn = (props) => (
    <PrimaryBtn type='submit' {...props}>
        <Save height="1rem" /> Zapisz
    </PrimaryBtn>
)
